<div class="base-container">
  <!-- SELECTION BAR (MULTIPLE REGIONS) -->
  @let egpRegionsValue = egpRegions();
  @let egpDataValue = egpData();
  @let selectedRegionValue = selectedRegion();
  @let langSignalValue = languageService.langSignal();
  @if (egpRegionsValue.summer.length + egpRegionsValue.winter.length > 1) {
    <!-- SCENARIO A: DROPDOWN SELECTION (MULTIPLE REGIONS) -->
    <div class="panel egp-panel">
      <mat-form-field
        appearance="fill"
        [ngClass]="
          (isHandset$ | async) ? 'region-select-small' : 'region-select'
        ">
        <mat-label>{{ 'PRODUCT.WARNING.select' | translate }}</mat-label>
        <mat-select
          [formControl]="regionControl"
          placeholder="{{ 'PRODUCT.WARNING.select' | translate }}">
          @for (season of seasons(); track $index) {
            @if (egpRegionsValue[season].length > 0) {
              @for (region of egpRegionsValue[season]; track $index) {
                <mat-option
                  [value]="season + region.id"
                  (onSelectionChange)="onRegionChange(season, $event)">
                  {{ region.name }}
                </mat-option>
              }
            }
          }
        </mat-select>
      </mat-form-field>

      @if (egpDataValue && egpDataValue.hasOwnProperty('textObject')) {
        <div class="panel__text egp-meta-zone">
          <div class="egp-meta-line time-line">
            <fa-icon [icon]="['far', 'clock']" class="meta-icon"></fa-icon>
            <span>
              {{ 'PRODUCT.EGP.WRITTEN.TIME' | translate }}
              <strong>
                {{
                  egpDataValue['textObject']['prescribeAt']
                    | datex: 'DD.MM.YY HH:mm' : undefined : langSignalValue
                }}
              </strong>
            </span>
          </div>
          <div class="egp-meta-line forecaster-line">
            <fa-icon [icon]="['far', 'user-edit']" class="meta-icon"></fa-icon>
            <span>
              {{ 'PRODUCT.EGP.WRITTEN.MADE_BY_FORECASTER' | translate }}
              <strong>{{ egpDataValue.textObject.author }}</strong>
            </span>
          </div>
        </div>
      }
    </div>
  } @else {
    <!-- SCENARIO B: SELECTION BAR (SINGLE REGION PRESET) -->
    <div class="panel egp-panel">
      @if (selectedRegionValue) {
        <div class="panel__text egp-single-region-title">
          <fa-icon
            [icon]="['far', 'map-marker-alt']"
            class="region-marker-icon"></fa-icon>
          <span>{{ selectedRegionValue.name }}</span>
        </div>
      }

      @if (egpDataValue && egpDataValue.hasOwnProperty('textObject')) {
        <div class="panel__text egp-meta-zone">
          <div class="egp-meta-line time-line">
            <fa-icon [icon]="['far', 'clock']" class="meta-icon"></fa-icon>
            <span>
              {{ 'PRODUCT.EGP.WRITTEN.TIME' | translate }}
              <strong>
                {{
                  egpDataValue['textObject']['prescribeAt']
                    | datex: 'DD.MM.YY HH:mm' : undefined : langSignalValue
                }}
              </strong>
            </span>
          </div>
          <div class="egp-meta-line forecaster-line">
            <fa-icon [icon]="['far', 'user-edit']" class="meta-icon"></fa-icon>
            <span>
              {{ 'PRODUCT.EGP.WRITTEN.MADE_BY_FORECASTER' | translate }}
              <strong>{{ egpDataValue.textObject.author }}</strong>
            </span>
          </div>
        </div>
      }
    </div>
  }

  <!-- EGP CONTENT -->
  @if (
    selectedRegionValue &&
    egpDataValue &&
    egpDataValue.hasOwnProperty('textObject')
  ) {
    <!-- Der optimierte zweiseitige Grid-Container -->
    <div class="egp-two-column-grid">
      @let fcstTime =
        {
          summer: '8',
          winter: '10',
        };
      @let forecastForSeasonTranslation =
        'PRODUCT.EGP.forecast.' + selectedRegionValue.season | translate;
      @let amTranslation = 'PRODUCT.EGP.am' | translate;
      @let untilTranslation = 'PRODUCT.EGP.until' | translate;
      @let fcstTimeForSeason = fcstTime[selectedRegionValue.season];

      <!-- 1. RISKBOX CARDS (Tag 0 und 1) -->
      @for (day of [0, 1]; track $index) {
        @if (egpDataValue.textObject.texts[day].text.length > 2) {
          <div class="risk-card egp-risk-card-item">
            <mat-card appearance="outlined">
              <mat-card-content class="risk-card-body-layout">
                @if (
                  selectedRegionValue | showRiskbox: auth.isPigeonCustomer()
                ) {
                  <div
                    [id]="'svg' + day"
                    class="risk-card__riskgraphic-container"></div>
                  @if (egpDataValue.matrices.length > day) {
                    <app-riskbox
                      [riskBoxdata]="egpDataValue.matrices[day]"
                      [svgid]="'svg' + day"
                      [mini]="false"
                      [season]="selectedRegionValue.season">
                    </app-riskbox>
                  }
                }

                <div class="risk-card__text-container">
                  @if (
                    day === 0 && selectedRegionValue
                      | showRiskbox: auth.isPigeonCustomer()
                  ) {
                    <p class="risk-card__change-container status-change-p">
                      @if (isRiskboxDifferent()) {
                        <span class="status-change-yes">
                          <fa-icon
                            [icon]="['far', 'check-square']"
                            size="lg"></fa-icon>
                          &nbsp;{{ 'PRODUCT.EGP.statusChangeYes' | translate }}
                        </span>
                      } @else {
                        <span class="status-change-no">
                          <fa-icon
                            [icon]="['far', 'square']"
                            size="lg"></fa-icon>
                          &nbsp;{{ 'PRODUCT.EGP.statusChangeNo' | translate }}
                        </span>
                      }
                    </p>
                  }
                  @if (
                    selectedRegionValue | showRiskbox: auth.isPigeonCustomer()
                  ) {
                    @let wday = egpDataValue | wDay: day;
                    @let title =
                      wday
                        | title
                          : day
                          : fcstTimeForSeason
                          : forecastForSeasonTranslation
                          : amTranslation
                          : untilTranslation;
                    <h2 class="risk-card-headline">
                      {{ title }}
                    </h2>
                  }

                  <div class="risk-card-text-paragraphs">
                    @for (
                      textline of egpDataValue.textObject.texts[day].text.split(
                        '\n'
                      );
                      track $index
                    ) {
                      <p class="risk-text-line">
                        {{ textline }}
                      </p>
                    }
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }
      }

      <!-- 2. RISKBAR CARDS (Tag 2 und 3 - Erweiterte Tage) -->
      @for (day of [2, 3]; track $index) {
        @if (selectedRegionValue | showMoreDays) {
          <div class="risk-card egp-risk-card-item">
            <mat-card appearance="outlined">
              <mat-card-content class="risk-card-body-layout">
                @if (!auth.isPigeonCustomer()) {
                  <div class="risk-card__riskgraphic-container">
                    <app-riskbar
                      [riskBoxdata]="egpDataValue.matrices[day]"
                      [season]="selectedRegionValue.season">
                    </app-riskbar>
                  </div>
                }
                <div class="risk-card__text-container">
                  @if (!auth.isPigeonCustomer()) {
                    @let wday = egpDataValue | wDay: day;
                    @let title =
                      wday
                        | title
                          : day
                          : fcstTimeForSeason
                          : forecastForSeasonTranslation
                          : amTranslation
                          : untilTranslation;
                    <h2 class="risk-card-headline">
                      {{ title }}
                    </h2>
                  }

                  <div class="risk-card-text-paragraphs">
                    @for (
                      textline of egpDataValue.textObject.texts[day].text.split(
                        '\n'
                      );
                      track $index
                    ) {
                      <p class="risk-text-line">
                        {{ textline }}
                      </p>
                    }
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }
      }
    </div>
  }

  <!-- NO EGP DATA FOR REGION -->
  @if (selectedRegionValue && (egpDataValue | key).length === 0) {
    <mat-card appearance="outlined" class="no-data-card">
      <mat-card-content>
        <div class="no-data-card__content">
          <fa-icon [icon]="['far', 'align-slash']" [size]="'4x'"></fa-icon>
          <p>{{ 'PRODUCT.EGP.NO_EGP_INFO' | translate }}</p>
        </div>
      </mat-card-content>
    </mat-card>
  }

  <a id="cardsLegend"></a>

  @if (
    selectedRegionValue &&
      (egpDataValue | key).length > 0 &&
      selectedRegionValue.hasOwnProperty('season') &&
      selectedRegionValue | showRiskbox: auth.isPigeonCustomer()
  ) {
    <mat-card appearance="outlined" class="legend-card egp-legend-card">
      <button
        mat-icon-button
        class="up-button"
        (click)="onClickScrollToStart()"
        [matTooltip]="'Nach oben scrollen'">
        <fa-icon [icon]="['far', 'chevron-up']"></fa-icon>
      </button>

      <mat-card-header>
        <fa-icon
          mat-card-avatar
          [icon]="['far', 'info-circle']"
          size="lg"
          transform="right-4 down-4"></fa-icon>
        <mat-card-title>{{
          'PRODUCT.EGP.LEGENDE.TITLE' | translate
        }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="egp-legend-content-zone">
        <!-- ========================================== -->
        <!-- FALL 1: WINTER-LEGENDE                     -->
        <!-- ========================================== -->
        @if (selectedRegionValue.season === 'winter') {
          <div class="egp-legend-wrapper winter-mode">
            <table class="egp-legend-table">
              <thead>
                <tr>
                  <th class="col-area">
                    <b>{{ 'PRODUCT.EGP.LEGENDE.AREA_MEANS' | translate }}:</b>
                  </th>
                  <th class="col-risk">
                    <b>{{ 'PRODUCT.EGP.LEGENDE.RISK_MEANS' | translate }}:</b>
                  </th>
                  <th class="col-type-color"></th>
                  <th class="col-type-text">
                    <b
                      >{{
                        'PRODUCT.EGP.LEGENDE.SLICKNESS_TYPES' | translate
                      }}:</b
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ 'PRODUCT.EGP.RISKBOX.Gx' | translate }} =
                    {{ 'PRODUCT.EGP.LEGENDE.BRIDGES' | translate }}
                  </td>
                  <td>25%</td>
                  <td><div class="legend-color-box block-reif"></div></td>
                  <td>{{ 'PRODUCT.EGP.RISKBOX.REIF' | translate }}</td>
                </tr>
                <tr>
                  <td>
                    {{ 'PRODUCT.EGP.RISKBOX.G1' | translate }} =
                    {{ 'PRODUCT.EGP.LEGENDE.EXPOSED_AREAS' | translate }}
                  </td>
                  <td>50%</td>
                  <td><div class="legend-color-box block-naesse"></div></td>
                  <td>{{ 'PRODUCT.EGP.RISKBOX.NAESSE' | translate }}</td>
                </tr>
                <tr>
                  <td>
                    {{ 'PRODUCT.EGP.RISKBOX.G2' | translate }} =
                    {{ 'PRODUCT.EGP.LEGENDE.MANY_SECTIONS' | translate }}
                  </td>
                  <td>75%</td>
                  <td><div class="legend-color-box block-schnee"></div></td>
                  <td>{{ 'PRODUCT.EGP.RISKBOX.SCHNEE' | translate }}</td>
                </tr>
                <tr>
                  <td>
                    {{ 'PRODUCT.EGP.RISKBOX.G3' | translate }} =
                    {{ 'PRODUCT.EGP.LEGENDE.WHOLE_AREA' | translate }}
                  </td>
                  <td>99%</td>
                  <td><div class="legend-color-box block-eis"></div></td>
                  <td>{{ 'PRODUCT.EGP.RISKBOX.EIS' | translate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        } @else {
          <div class="egp-legend-wrapper summer-mode">
            <table class="egp-legend-table">
              <thead>
                <tr>
                  <th class="col-type"></th>
                  <th colspan="2" class="text-left">
                    1 {{ 'PRODUCT.EGP.LEGENDE.BOX' | translate }}
                  </th>
                  <th colspan="2" class="text-left">
                    2 {{ 'PRODUCT.EGP.LEGENDE.BOXES' | translate }}
                  </th>
                  <th colspan="2" class="text-left">
                    3 {{ 'PRODUCT.EGP.LEGENDE.BOXES' | translate }}
                  </th>
                  <th colspan="2" class="text-left">
                    4 {{ 'PRODUCT.EGP.LEGENDE.BOXES' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="subheader-row">
                  <td></td>
                  <td colspan="2">
                    {{ 'PRODUCT.EGP-SUMMER.RISKBOX.WARNLEVEL' | translate }} 1
                  </td>
                  <td colspan="2">
                    {{ 'PRODUCT.EGP-SUMMER.RISKBOX.WARNLEVEL' | translate }} 2
                  </td>
                  <td colspan="2">
                    {{ 'PRODUCT.EGP-SUMMER.RISKBOX.WARNLEVEL' | translate }} 3
                  </td>
                  <td colspan="2">
                    {{ 'PRODUCT.EGP-SUMMER.RISKBOX.WARNLEVEL' | translate }} 4
                  </td>
                </tr>
                <tr class="content-row">
                  <td>{{ 'PRODUCT.EGP-SUMMER.RISKBOX.TYPES' | translate }}</td>
                  <td><div class="legend-color-box block-gewitter"></div></td>
                  <td>
                    &nbsp;{{
                      'PRODUCT.EGP-SUMMER.RISKBOX.THUNDERSTORM' | translate
                    }}
                  </td>
                  <td><div class="legend-color-box block-regen"></div></td>
                  <td>
                    &nbsp;{{ 'PRODUCT.EGP-SUMMER.RISKBOX.DRAIN' | translate }}
                  </td>
                  <td><div class="legend-color-box block-sturm"></div></td>
                  <td>
                    &nbsp;{{ 'PRODUCT.EGP-SUMMER.RISKBOX.STORM' | translate }}
                  </td>
                  <td><div class="legend-color-box block-hitze"></div></td>
                  <td>
                    &nbsp;{{ 'PRODUCT.EGP-SUMMER.RISKBOX.HEAT' | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }
  &nbsp;
</div>

<!-- SIDENAV SETTINGS -->
<div class="settings-button-stack">
  <!--legend button-->
  <button
    mat-mini-fab
    class="settings-button"
    (click)="onClickScroll('cardsLegend')"
    tp="{{ 'PRODUCT.SMW.LEGENDE.TITLE' | translate }}"
    variation="popper"
    trigger="mouseenter"
    tpPlacement="left">
    <fa-icon [icon]="['far', 'info-circle']" size="lg"></fa-icon>
  </button>
</div>
